import { debounce } from "lodash";
import { calcularAvisosRecomendacao } from "../utils/regrasObjetivo";
const imgLink = require("../../../img/bg-modal.svg");

const modalComplexo = {
	props: [
		"objetivos_api",
		"step",
		"objetivos",
		"tipo_atual",
		"campos_objetivo",
		"nome_correto",
		"product_type_name",
		"loading",
		"origin_click",
		"status_campos",
	],
	data() {
		return {
			bgModal: imgLink,
			baseURL: window.location.origin,
			showErrorOnModal: false,
			isValidModalObjective: true,
			errorMessage: "",
			showError: false,
			isPercentFull: false,
			modalIsOpen: false,
			showErrorOnModal: false,
			isPercentFull: false,
			modalErrorMessage: "",
			modalValueIsValid: false,
			show: false,
			search: "",
			objEdicao: null,
			modalState: "",
			stepAnterior: null,
			objetivoFiltrado: "",
			baseURL: window.location.origin,
			quantidadeSteps: 8,
			hasZeroValues: false,
			hasSameValue: false,
			textoBotao: "Continuar",
			novoObjetivo: {
				nome: "",
				porcentagem: "",
			},
			showOptions: "",
			showOptionsFirst: false,
			idDoObjetivoAtual: "",
			options: [],
			optionsRendaFixa: [
				{
					value: "Tesouro IPCA+",
					label: "Tesouro IPCA+",
					ticker_symbol: "Tesouro IPCA+",
				},
			],
			isLoading: false,
			selected: null,
			pastTotalValue: 0,
			// Exclusoes pendentes escopadas por aba/classe: { [tipo]: [ids] }.
			// Evita arrastar remocoes de uma classe no save de outra.
			idsExcluidos: {},
			protocol: window.location.protocol,
			isValidModalSimple: true,
		};
	},

	mounted() {
		document.addEventListener("click", (e) => this.outsideClick(e));
	},

	watch: {
		valor_total_computado(newValue, oldValue) {
			if (!this.valor_total_computado) return;
			this.checkSumValueInInlineSteps();
		},

		step(newValue, oldValue) {
			const { id, tipo } = newValue;
			if (id === 5) {
				this.checkSumValueInInlineSteps();
			}
		},
	},

	computed: {
		avisosRecomendacao() {
			return calcularAvisosRecomendacao(this.campos_objetivo);
		},

		valor_total_computado() {
			const objetivoAtual = this.objetivos[this.step.tipo];
			if (!objetivoAtual) {
				return 0;
			}
			const porcentagens = objetivoAtual.map((objetivo) =>
				Number(objetivo.porcentagem_desejada)
			);
			const total = porcentagens.reduce(
				(acc, porcentagem) => acc + porcentagem,
				0
			);
			// return Math.round(total);
			return Math.round((total + Number.EPSILON) * 100) / 100;
		},

		nome() {
			if (this.tipo_atual == "titulos" || this.tipo_atual == "titulos_inicio") {
				return "Tesouro Direto";
			} else if (this.tipo_atual == "reits") {
				return "Reits";
			} else if (this.tipo_atual == "stocks") {
				return "Stocks";
			} else if (this.tipo_atual == "acoes") {
				return "Ações";
			} else if (this.tipo_atual == "fiis") {
				return "FIIs";
			}
			return "default";
		},

		textoModal() {
			if (this.step.tipo == "acoes") {
				return "Qual o seu objetivo com esta ação?";
			} else if (this.step.tipo == "fiis") {
				return "Qual o seu objetivo com este FII?";
			} else if (this.step.tipo == "stocks") {
				return "Qual o seu objetivo com este Stock?";
			} else if (this.step.tipo == "reits") {
				return "Qual o seu objetivo com este Reit";
			} else if (this.step.tipo == "tesouro_direto") {
				return "Qual o seu objetivo com este Titulo de renda fixa?";
			} else {
				return "";
			}
		},
	},

	methods: {
		/**
		 * Avisos de recomendação (não bloqueantes) da fase informada, para
		 * exibição inline dentro do modal — ver regrasObjetivo.js.
		 */
		avisosDaFase(fase) {
			return this.avisosRecomendacao.filter((aviso) => aviso.fase === fase);
		},

		limitQuantityNumberAfterVirgula(input1 = null, input2 = null) {
			if (
				input1 &&
				input1.value !== null &&
				input1.value.toString().indexOf(".") !== -1
			) {
				const partes = input1.value.toString().split(".");
				if (partes[1].length > 2) {
					input1.value = parseFloat(partes[0] + "." + partes[1].substr(0, 2));
					this.novoObjetivo.porcentagem = input1.value;
				}
			}

			if (
				input2 &&
				input2.value !== null &&
				input2.value.toString().indexOf(".") !== -1
			) {
				const partes = input2.value.toString().split(".");
				if (partes[1].length > 2) {
					input2.value = parseFloat(partes[0] + "." + partes[1].substr(0, 2));
				}
			}
		},

		/* Funções responsáveis por calcular valor dos objetivos*/
		checkSumValueInNormalSteps({ currentTarget, target }) {
			const cardItem = document.querySelector(`.step-${this.step.id}`);
			const pai = cardItem.parentElement;
			const numeroPermitido = 100;
			console.log(numeroPermitido);
			const inputs = [...cardItem.querySelectorAll("input")];
			const [input1, input2] = inputs;
			let soma;
			// if (!currentTarget) return;
			if (currentTarget.value > numeroPermitido) currentTarget.value = "";

			this.limitQuantityNumberAfterVirgula(input1, input2);
			this.defineDynamicValueFromInputsInNormalSteps(
				currentTarget,
				input1,
				input2
			);
			soma = Number(input1.value) + Number(input2.value);
			this.compareSumValuesInNormalSteps(soma);
		},

		dropdownShouldOpen(VueSelect) {
			if (this.options.length) {
				return VueSelect.open;
			}

			return VueSelect.search.length !== 0 && VueSelect.open;
		},

		defineDynamicValueFromInputsInNormalSteps(
			elAtivo,
			firstInput,
			secondInput
		) {
			const attrName1 = firstInput.getAttribute("name");
			const attrName2 = secondInput.getAttribute("name");
			if (elAtivo == firstInput) {
				secondInput.value = (100 - firstInput.value).toFixed(2);
				this.campos_objetivo[attrName1] = parseFloat(firstInput.value);
				this.campos_objetivo[attrName2] = parseFloat(secondInput.value);
			} else if (elAtivo == secondInput) {
				firstInput.value = (100 - secondInput.value).toFixed(2);
				this.campos_objetivo[attrName1] = parseFloat(firstInput.value);
				this.campos_objetivo[attrName2] = parseFloat(secondInput.value);
			}
			this.campos_objetivo[attrName1] == 0 ||
			this.campos_objetivo[attrName2] == 0
				? (this.hasZeroValues = true)
				: (this.hasZeroValues = false);
		},

		compareSumValuesInNormalSteps(soma) {
			if (soma > 100 || soma != 100) {
				this.isValidModalSimple = false;
				this.showError = true;
				this.errorMessage = "O somatório precisa ser igual a 100%";
				return;
			}
			this.isValidModalSimple = true;
		},

		checkSumValueInInlineSteps() {
			if (
				this.valor_total_computado > 100 ||
				this.valor_total_computado !== 100
			) {
				this.isValidModalObjective = false;
				this.isPercentFull = false;
				this.showError = true;
				this.errorMessage = "O somatório precisa ser igual a 100%";
			} else if (this.valor_total_computado == 100) {
				this.isValidModalObjective = true;
				this.isPercentFull = true;
			}
		},

		/* Funções que previne a adição de ativos que já existem no objetivo*/
		checkIfStringExistsOnObject() {
			if (this.modalState == "adicionar") {
				let equal = this.objetivos[this.tipo_atual].some(
					(i) => i.ticker_symbol == this.novoObjetivo.nome
				);
				if (equal) {
					this.hasSameValue = true;
					return;
				}
				this.hasSameValue = false;
			} else if (this.modalState == "editar") {
				let equal = this.objetivos[this.tipo_atual].some(
					(i) =>
						i.ticker_symbol == this.novoObjetivo.nome &&
						i.ticker_symbol != this.objEdicao.ticker_symbol
				);
				if (equal) {
					this.hasSameValue = true;
					this.modalValueIsValid = false;
					return;
				}
				this.novoObjetivo.porcentagem = this.objEdicao.porcentagem_desejada;
				this.hasSameValue = false;
				this.modalValueIsValid = true;
			}
		},

		handleSearchSelect(opcaoSelecionada) {
			if (!opcaoSelecionada.value) return;

			console.log(opcaoSelecionada);
			this.novoObjetivo.nome = opcaoSelecionada.value;
			this.preventInsertTheSameTickerSymbol();
		},

		preventInsertTheSameTickerSymbol() {
			this.checkIfStringExistsOnObject();
			if (this.hasSameValue) {
				this.showErrorOnModal = true;
				this.modalErrorMessage = "Esse ativo já foi adicionado antes";
				this.novoObjetivo.porcentagem = null;
				this.modalValueIsValid = false;
				return;
			} else {
				this.showErrorOnModal = false;
				this.modalErrorMessage = "";
			}
		},

		/* Funções responsáveis pelo pesquisar e setar as options dentro do Choices */

		onSearch(search, loading) {
			if (this.product_type_name == "TesouroDireto") return;
			if (search.length) {
				loading(true);
				this.getDataOnSearchSelect(loading, search, this);
			}
		},

		getDataOnSearchSelect: debounce(async function (loading, search, vm) {
			try {
				let data;
				if (this.tipo_atual == "titulos") {
					const response = await fetch(
						`${this.baseURL}/api/tesouro_direto/?ticker_symbol=${search}`
					);
					data = await response.json();
				} else {
					const response = await fetch(
						`${this.baseURL}/api/${this.tipo_atual}/?ticker_symbol=${search}`
					);
					data = await response.json();
				}
				this.options = data.map(({ ticker_symbol }) => ({
					value: ticker_symbol,
					label: ticker_symbol,
					ticker_symbol: ticker_symbol,
				}));
				loading(false);
				this.isLoading = false;
			} catch (error) {
				// GLOBAL.showToastify(error);
				console.error(error);
				loading(false);
				this.isLoading = false;
			} finally {
				loading(false);
				this.isLoading = false;
			}
		}, 600),

		/* Funções responsável por controlar array do objeto de edição */
		setAEditObjectiveToArray(id) {
			this.modalIsOpen = true;
			const { tipo } = this.step;
			const filterObjetivo = this.objetivos[tipo].filter((item) => {
				return item.id == id;
			});
			this.objEdicao = filterObjetivo[0];
			this.setValuesOnEditStateModal(filterObjetivo);
		},

		setNewObjectiveValueInOnKeyupEdit({ target }, cancelar) {
			const tipo = this.step?.tipo ?? "";

			if (cancelar || !tipo) {
				// Se cancelar ou tipo não estiver definido, sai da função
				return;
			}

			if (target) {
				this.limitQuantityNumberAfterVirgula(target);
				const updatedObjectives = this.objetivos[tipo].map((item) => {
					if (item.id === this.objEdicao.id) {
						// Se estiver editando, atualiza com o novo valor ou valor original
						const porcentagem =
							this.novoObjetivo.porcentagem ?? item.porcentagem_desejada;
						return { ...item, porcentagem_desejada: porcentagem };
					}
					return item;
				});
				this.objetivos[tipo] = updatedObjectives;

				this.validateModalFieldsOnEdit(target);
			}
		},

		updateObjectiveValue(item) {
			return {
				...item,
				porcentagem_desejada: this.novoObjetivo.porcentagem,
			};
		},
		setValuesOnEditStateModal(array) {
			this.novoObjetivo.nome = array[0].ticker_symbol;
			this.novoObjetivo.porcentagem = array[0].porcentagem_desejada;
		},

		/*Função responsável por ativar o modal e suas respectivas ações */

		activateModal(valor, objetivo, ticker_symbol, id) {
			this.modalIsOpen = true;
			this.modalState = valor;
			this.pastTotalValue = this.valor_total_computado;
			switch (this.modalState) {
				case "adicionar":
					this.options = [];
					this.novoObjetivo = {
						nome: "",
						porcentagem: "",
					};
					this.modalValueIsValid = false;
					this.hasSameValue = false;
					this.showErrorOnModal = false;
					break;
				case "editar":
					this.modalValueIsValid = false;
					this.hasSameValue = false;
					this.showErrorOnModal = false;
					const nomeAtivo = this.objetivos[this.step.tipo]
						.filter((i) => i.id === id)
						.reduce((acc, i) => (acc = i), {});
					this.options = [
						{
							value: nomeAtivo.ticker_symbol,
							label: nomeAtivo.ticker_symbol,
						},
					];
					this.setAEditObjectiveToArray(id);
					break;
			}
		},

		/* Função responsável por salvar uma edição ou criação de objetivo*/
		defineTickerSymbolInEdit() {
			console.log(this.novoObjetivo.nome);
			if (this.novoObjetivo.nome.ticker_symbol) {
				return this.novoObjetivo.nome.ticker_symbol;
			} else if (this.novoObjetivo.nome.value) {
				return this.novoObjetivo.nome.value;
			} else {
				return this.novoObjetivo.nome;
			}
		},

		editAExistantObjetive() {
			const { tipo } = this.step;
			const objetivosFiltrados = this.objetivos[tipo].map((item) => {
				if (item.id == this.objEdicao.id) {
					return {
						...item,
						ticker_symbol: this.defineTickerSymbolInEdit(),
						porcentagem_desejada: this.novoObjetivo.porcentagem,
					};
				}
				return item;
			});
			this.objetivos[tipo] = objetivosFiltrados;
			this.checkSumValueInInlineSteps();
			this.modalIsOpen = false;
		},

		saveANewObjective(event) {
			const modalResponsavel = event.currentTarget.closest(`.modal-adicao`);
			const { tipo } = this.step;
			const objetivosAtuais = this.objetivos[tipo];
			console.log(GLOBAL.generateUUID(), this.protocol);
			this.objetivos[tipo] = [
				...objetivosAtuais,
				{
					id:
						this.protocol === "https:"
							? crypto.randomUUID()
							: GLOBAL.generateUUID(),
					ticker_symbol: this.novoObjetivo.nome,
					porcentagem_desejada: this.novoObjetivo.porcentagem,
					objetivo: this.objetivos_api[0].id,
					tipo_ativo: `${this.tipo_atual != "titulos" ? "Variavel" : "Fixa"}`,
					product_type_name: this.product_type_name,
				},
			];

			this.checkSumValueInInlineSteps();
			this.resetModalForm();
			this.modalIsOpen = false;
		},

		async saveANewObjectiveOnApi() {
			try {
				const { tipo } = this.step;
				const objetivosAtuais = this.objetivos[tipo];
				const keyToRemove = "id";
				const objetivosAtuaisParaApi = objetivosAtuais.map((obj) => {
					const { [keyToRemove]: removedKey, ...rest } = obj;
					return rest;
				});

				// So envia as exclusoes DESTA aba (classe). idsExcluidos e
				// escopado por tipo para nao arrastar remocoes de outra classe
				// (ex.: salvar Stocks nao pode apagar itens de Acoes).
				const idsDaAba = this.idsExcluidos[tipo] || [];
				const idParaExclusaoSemCryptoID = idsDaAba.filter(
					(item) => !isNaN(item) && typeof item === "number"
				);
				const { data } = await axios.post(`${this.baseURL}/editar-objetivo/`, {
					...objetivosAtuaisParaApi,
					ids: idParaExclusaoSemCryptoID,
				});
				// Exclusoes desta aba ja persistidas: zera so as dela.
				this.idsExcluidos[tipo] = [];
				this.sucessConfirmation();
			} catch (error) {
				// O backend (editar_objetivo) valida a integridade do objetivo e
				// responde 400 com { message, erros: [...] } quando alguma classe
				// nao fecha 100%. Mostra esses erros em vez do objeto de erro cru.
				const data = error?.response?.data;
				const mensagem =
					data?.erros?.length > 0
						? data.erros.join(" ")
						: data?.message ||
						  "Nao foi possivel salvar o objetivo. Tente novamente.";
				GLOBAL.showToastify(mensagem, "#DE4B4F");
				console.error(error);
				return;
			}
		},

		removeObjective(id) {
			const { tipo } = this.step;
			if (id) {
				// Escopa a exclusao na aba (classe) atual: so e enviada quando
				// ESTA aba for salva, nunca junto com o save de outra classe.
				if (!this.idsExcluidos[tipo]) this.idsExcluidos[tipo] = [];
				this.idsExcluidos[tipo].push(id);
			}
			this.objetivos[tipo] = this.objetivos[tipo].filter((item) => {
				console.log(item.id, id);

				return item.id !== id;
			});
			this.checkSumValueInInlineSteps();
		},

		/* Validações*/
		validateModalFieldsOnAdd({ target }) {
			this.limitQuantityNumberAfterVirgula(target);
			if (!this.novoObjetivo.nome || !this.novoObjetivo.porcentagem) {
				this.modalValueIsValid = false;
				this.showErrorOnModal = true;
				this.modalErrorMessage = "Os campos não podem estar vazios";
			} else if (
				this.valor_total_computado + this.novoObjetivo.porcentagem >
				100
			) {
				this.modalValueIsValid = false;
				this.showErrorOnModal = true;
				this.modalErrorMessage = "O somatório precisa ser igual a 100%";
				this.novoObjetivo.porcentagem = "";
			} else {
				this.modalValueIsValid = true;
				this.showErrorOnModal = false;
				this.modalErrorMessage = "";
			}
		},

		returnToOriginalValueObjetive() {
			this.novoObjetivo.porcentagem = this.objEdicao?.porcentagem_desejada;
			const updatedObjectives = this.objetivos[this.step.tipo].map((item) => {
				if (item.id === this.objEdicao.id) {
					const porcentagem =
						this.novoObjetivo.porcentagem ?? item.porcentagem_desejada;
					return { ...item, porcentagem_desejada: porcentagem };
				}
				return item;
			});
			this.objetivos[this.step.tipo] = updatedObjectives;
			this.modalValueIsValid = true;
		},

		validateModalFieldsOnEdit(target) {
			this.limitQuantityNumberAfterVirgula(target);
			if (!this.novoObjetivo.porcentagem) {
				this.modalValueIsValid = false;
				this.showErrorOnModal = true;
				this.modalErrorMessage = "Os campos não podem estar vazios";
			} else if (
				this.valor_total_computado > 100 ||
				this.novoObjetivo.porcentagem > 100
			) {
				this.modalValueIsValid = false;
				this.showErrorOnModal = true;
				this.modalErrorMessage = "O somatório precisa ser igual a 100%";
				this.returnToOriginalValueObjetive();
			} else {
				this.modalValueIsValid = true;
				this.showErrorOnModal = false;
				this.modalErrorMessage = "";
			}
		},

		async sucessConfirmation() {
			GLOBAL.showToastify("Objetivo editado com sucesso!");
			await getObjetivos();
		},

		//Essa função é responsável por mudar
		wizardUpdate() {
			if (
				this.step.id === 4 &&
				this.step.tipo === "stocks" &&
				this.campos_objetivo.pr_stocks
			) {
				this.$emit("update-nome", "Stock");
				this.$parent.updateValueStep(5, "stocks");
			} else if (
				this.step.id === 1 &&
				this.step.tipo === "titulos_inicio" &&
				this.campos_objetivo.pr_renda_fixa
			) {
				this.$emit("update-nome", "TesouroDireto");
				this.$parent.updateValueStep(5, "titulos");
			} else if (
				this.step.id === 4 &&
				this.step.tipo === "reits" &&
				this.campos_objetivo.pr_reits
			) {
				this.$emit("update-nome", "Reit");
				this.$parent.updateValueStep(5, "reits");
			} else if (
				this.step.id === 3 &&
				this.step.tipo === "acoes" &&
				this.campos_objetivo.pr_acoes
			) {
				this.$emit("update-nome", "Ação");
				this.$parent.updateValueStep(5, "acoes");
			} else if (
				this.step.id === 3 &&
				this.step.tipo === "fiis" &&
				this.campos_objetivo.pr_fiis
			) {
				this.$emit("update-nome", "Fii");
				this.$parent.updateValueStep(5, "fiis");
			} else {
				this.sucessConfirmation();
			}
		},
		SendEmitForOpenAEspecificModal() {
			if (
				this.step.id === 1 &&
				this.step.tipo === "titulos_inicio" &&
				this.campos_objetivo.pr_renda_fixa
			) {
				this.$emit("openModal", 5, "titulos_inicio");
			} else if (
				this.step.id === 4 &&
				this.step.tipo === "stocks" &&
				this.campos_objetivo.pr_stocks
			) {
				this.$emit("openModal", 5, "stocks");
			} else if (
				this.step.id === 4 &&
				this.step.tipo === "reits" &&
				this.campos_objetivo.pr_reits
			) {
				this.$emit("openModal", 5, "reits");
			} else if (
				this.step.id === 3 &&
				this.step.tipo === "acoes" &&
				this.campos_objetivo.pr_acoes
			) {
				this.$emit("openModal", 5, "acoes");
			} else if (
				this.step.id === 3 &&
				this.step.tipo === "fiis" &&
				this.campos_objetivo.pr_fiis
			) {
				this.$emit("openModal", 5, "fiis");
			}
		},

		/* Envio do formulário */
		onSubmitAction({ currentTarget }, nameInput1, nameInput2) {
			const form = currentTarget;
			const cardItem = document.querySelector(`.step-${this.step.id}`);
			const inputs = [...cardItem.querySelectorAll("input")];
			const [input1, input2] = inputs;
			console.log(currentTarget, nameInput1, nameInput2);
			axios
				.patch(`${this.baseURL}/api/objetivo/${this.objetivos_api[0].id}/`, {
					...this.campos_objetivo,
					[nameInput1]: Number(input1.value),
					[nameInput2]: Number(input2.value),
				})
				.then(({ data }) => {
					this.wizardUpdate();
					this.SendEmitForOpenAEspecificModal();
				})
				.catch((error) => {
					GLOBAL.showToastify(error, "#DE4B4F");
					console.error(error);
				});
		},

		onSubmitActionInlineCase() {
			this.sucessConfirmation();
		},

		/* Reset */
		resetModalForm() {
			this.novoObjetivo = {
				nome: "",
				porcentagem: "",
			};
		},

		handleClickInOptions(id) {
			this.showOptions = id;
			this.showOptionsFirst = true;
		},

		outsideClick({ target }) {
			if (target.closest(".icone-three-points")) return;
			this.showOptionsFirst = false;
		},

		onCloseModal() {
			this.modalIsOpen = false;
			const valoresOriginais = this.objetivos[this.step.tipo].map(
				(objetivo) => ({ ...objetivo })
			);
			this.objetivos[this.step.tipo] = valoresOriginais;
			this.setNewObjectiveValueInOnKeyupEdit(false, true);
			this.pastTotalValue = 0;
			this.returnToOriginalValueObjetive();
			this.hasSameValue = false;
			this.showErrorOnModal = false;
			this.modalErrorMessage = "";
		},
		showai() {
			console.log(this.objetivos_api[0]);
		},
	},

	template: html`
		<div>
			<div class="modal-edicao-objetivo" data-position="center">
				<!--MODAL DA RENDA FIXA E RENDA VARIAVEL = STEP 1-->
				<section class="modal--content" data-id="1">
					<div class="modal-header">
						<img :src="bgModal" alt="" class="bg-header-modal" />
						<h3>Editar Objetivo</h3>
						<button
							class="close-modal"
							type="button"
							data-id="1"
							data-xclose="modal-edicao-objetivo"
							@click="(e)=>onCloseModal(e)"
						>
							<svg class="w-8 h-8">
								<use xlink:href="#icon-close"></use>
							</svg>
						</button>
					</div>
					<div class="conteudo step-1 p-24">
						<p
							class="text-base font-normal tracking-tight text-white leading-150 "
						>
							Qual a sua porcentagem desejável em renda fixa e em renda
							variável?
						</p>
						<form
							class="!p-0"
							@submit.prevent="(e) => onSubmitAction(e,'pr_renda_fixa', 'pr_renda_variavel')"
							@keydown.enter="$event.preventDefault()"
						>
							<div class="mt-24 input-box">
								<label for="pr_renda_fixa" class="block label"
									>Renda fixa</label
								>
								<div class="input-icon">
									<input
										type="number"
										id="pr_renda_fixa"
										name="pr_renda_fixa"
										@input="checkSumValueInNormalSteps"
										placeholder="%"
										class="w-full h-48 text-sm input-text"
										v-model.number="campos_objetivo.pr_renda_fixa"
										:min="0"
										:max="100"
										step="0.01"
									/>

									<svg>
										<use xlink:href="#icon-percent"></use>
									</svg>
								</div>
							</div>
							<div class="mt-16 input-box">
								<label for="pr_renda_variavel" class="block label"
									>Renda variável</label
								>
								<div class="input-icon">
									<input
										type="number"
										id="pr_renda_variavel"
										name="pr_renda_variavel"
										v-model.number="campos_objetivo.pr_renda_variavel"
										@input="checkSumValueInNormalSteps"
										placeholder="%"
										class="w-full h-48 text-sm input-text"
										:min="0"
										:max="100"
										step="0.01"
									/>
									<svg>
										<use xlink:href="#icon-percent"></use>
									</svg>
								</div>
							</div>
							<div
								class="mt-16 error-message texthelper-icon"
								data-tippy-content="helper"
								v-show="!isValidModalSimple && showError"
							>
								<svg>
									<use xlink:href="#icon-helper"></use>
								</svg>

								<span class="text-sm">{{ errorMessage }}</span>
							</div>
							<div
								class="mt-16 aviso-recomendacao text-alert-red-100"
								v-for="aviso in avisosDaFase('macro')"
								:key="aviso.mensagem"
							>
								<svg>
									<use xlink:href="#icon-helper"></use>
								</svg>
								<span class="text-sm">{{ aviso.mensagem }}</span>
							</div>
							<div class="grid grid-cols-12 gap-16 mt-32 btn-container">
								<button
									type="button"
									class="col-span-6 btn bg-primary-10-o text-primary-60-pure"
									:data-id="step.id"
									data-xclose="modal-edicao-objetivo"
									@click="(e)=>onCloseModal(e)"
								>
									Cancelar
								</button>
								<button
									type="submit"
									class="col-span-6 btn"
									:class="isValidModalSimple === true ? '' : 'disabled'"
								>
									{{textoBotao}}
								</button>
							</div>
						</form>
					</div>
				</section>

				<!--MODAL DO BRASIL E EUA = STEP 2 -->
				<section class="modal--content" data-id="2">
					<div class="modal-header">
						<img :src="bgModal" alt="" class="bg-header-modal" />
						<h3>Editar Objetivo</h3>
						<button
							class="close-modal"
							type="button"
							data-id="2"
							data-xclose="modal-edicao-objetivo"
							@click="(e)=>onCloseModal(e)"
						>
							<svg class="w-8 h-8">
								<use xlink:href="#icon-close"></use>
							</svg>
						</button>
					</div>
					<div class="conteudo step-2 p-24 ">
						<p
							class="text-base font-normal tracking-tight text-white leading-150"
						>
							Dentro da renda variável, qual a porcentagem desejável no Brasil e
							nos EUA?
						</p>
						<form
							class="!p-0"
							@submit.prevent="(e) => onSubmitAction(e,'pr_renda_variavel_br', 'pr_renda_variavel_eua')"
							@keydown.enter="$event.preventDefault()"
						>
							<div class="mt-24 input-box">
								<label for="pr_renda_variavel_br" class="block label"
									>Brasil</label
								>
								<div class="input-icon">
									<input
										type="number"
										id="pr_renda_variavel_br"
										name="pr_renda_variavel_br"
										v-model.number="campos_objetivo.pr_renda_variavel_br"
										@input="checkSumValueInNormalSteps"
										placeholder="%"
										class="w-full h-48 text-sm input-text"
										:min="0"
										:max="100"
										step="0.01"
									/>
									<svg>
										<use xlink:href="#icon-percent"></use>
									</svg>
								</div>
							</div>
							<div class="mt-16 input-box">
								<label for="pr_renda_variavel_eua" class="block label"
									>EUA</label
								>
								<div class="input-icon">
									<input
										type="number"
										id="pr_renda_variavel_eua"
										name="pr_renda_variavel_eua"
										@input="checkSumValueInNormalSteps"
										v-model.number="campos_objetivo.pr_renda_variavel_eua"
										placeholder="%"
										class="w-full h-48 text-sm input-text"
										:min="0"
										:max="100"
										step="0.01"
									/>
									<svg>
										<use xlink:href="#icon-percent"></use>
									</svg>
								</div>
							</div>
							<div
								class="mt-16 error-message texthelper-icon"
								data-tippy-content="helper"
								v-show="!isValidModalSimple && showError"
							>
								<svg>
									<use xlink:href="#icon-helper"></use>
								</svg>
								<span class="text-sm">{{ errorMessage }}</span>
							</div>
							<div
								class="mt-16 aviso-recomendacao text-alert-red-100"
								v-for="aviso in avisosDaFase('exterior')"
								:key="aviso.mensagem"
							>
								<svg>
									<use xlink:href="#icon-helper"></use>
								</svg>
								<span class="text-sm">{{ aviso.mensagem }}</span>
							</div>
							<div class="grid grid-cols-12 gap-16 mt-32 btn-container">
								<button
									type="button"
									class="col-span-6 btn bg-primary-10-o text-primary-60-pure"
									:data-id="step.id"
									data-xclose="modal-edicao-objetivo"
									@click="(e)=> onCloseModal(e)"
								>
									Cancelar
								</button>
								<button
									type="submit"
									class="col-span-6 btn"
									:class="isValidModalSimple === true ? '' : 'disabled'"
									@click="showai"
								>
									Salvar
								</button>
							</div>
						</form>
					</div>
				</section>
				<!-- MODAL PARA FIIS E AÇÕES = STEP 3 -->
				<section class="modal--content" data-id="3">
					<div class="modal-header">
						<img :src="bgModal" alt="" class="bg-header-modal" />
						<h3>Editar Objetivo</h3>
						<button
							class="close-modal"
							type="button"
							data-id="3"
							data-xclose="modal-edicao-objetivo"
							@click="(e)=>onCloseModal(e)"
						>
							<svg class="w-8 h-8">
								<use xlink:href="#icon-close"></use>
							</svg>
						</button>
					</div>
					<div class="conteudo step-3 p-24 ">
						<p
							class="text-base font-normal tracking-tight text-white leading-150"
						>
							Na renda variável no Brasil, quando em ações e quanto em FIIs?
						</p>
						<form
							class="!p-0"
							@submit.prevent="(e) => onSubmitAction(e,'pr_acoes', 'pr_fiis')"
							@keydown.enter="$event.preventDefault()"
						>
							<div class="mt-24 input-box">
								<label for="pr_acoes" class="block label">Ações</label>
								<div class="input-icon">
									<input
										type="number"
										id="pr_acoes"
										name="pr_acoes"
										@input="checkSumValueInNormalSteps"
										v-model.number="campos_objetivo.pr_acoes"
										placeholder="%"
										class="w-full h-48 text-sm input-text"
										:min="0"
										:max="100"
										step="0.01"
									/>
									<svg>
										<use xlink:href="#icon-percent"></use>
									</svg>
								</div>
							</div>
							<div class="mt-16 input-box">
								<label for="pr_fiis" class="block label">FIIs</label>
								<div class="input-icon">
									<input
										type="number"
										id="pr_fiis"
										name="pr_fiis"
										@input="checkSumValueInNormalSteps"
										v-model.number="campos_objetivo.pr_fiis"
										placeholder="%"
										class="w-full h-48 text-sm input-text"
										:min="0"
										:max="100"
										step="0.01"
									/>
									<svg>
										<use xlink:href="#icon-percent"></use>
									</svg>
								</div>
							</div>
							<div
								class="mt-16 error-message texthelper-icon"
								data-tippy-content="helper"
								v-show="!isValidModalSimple && showError"
							>
								<svg>
									<use xlink:href="#icon-helper"></use>
								</svg>
								<span class="text-sm">{{ errorMessage }}</span>
							</div>
							<div
								class="mt-16 aviso-recomendacao text-alert-red-100"
								v-for="aviso in avisosDaFase('mix_br')"
								:key="aviso.mensagem"
							>
								<svg>
									<use xlink:href="#icon-helper"></use>
								</svg>
								<span class="text-sm">{{ aviso.mensagem }}</span>
							</div>
							<div class="grid grid-cols-12 gap-16 mt-32 btn-container">
								<button
									type="button"
									class="col-span-6 btn bg-primary-10-o text-primary-60-pure"
									:data-id="step.id"
									data-xclose="modal-edicao-objetivo"
									@click="(e)=>onCloseModal(e)"
								>
									Cancelar
								</button>
								<button
									type="submit"
									class="col-span-6 btn"
									:class="isValidModalSimple === true ? '' : 'disabled'"
								>
									{{textoBotao}}
								</button>
							</div>
						</form>
					</div>
				</section>
				<!-- MODAL PARA STOCKS E REITS = STEP 4 -->
				<section class="modal--content" data-id="4">
					<div class="modal-header">
						<img :src="bgModal" alt="" class="bg-header-modal" />
						<h3>Editar Objetivo</h3>

						<button
							class="close-modal"
							type="button"
							data-id="4"
							data-xclose="modal-edicao-objetivo"
							@click="(e)=>onCloseModal(e)"
						>
							<svg class="w-8 h-8">
								<use xlink:href="#icon-close"></use>
							</svg>
						</button>
					</div>
					<div class="conteudo step-4 p-24 ">
						<p
							class="text-base font-normal tracking-tight text-white leading-150"
						>
							Na renda variável no exterior, quando Stocks e em REITs? *
						</p>
						<form
							class="!p-0"
							@submit.prevent="(e) => onSubmitAction(e,'pr_stocks', 'pr_reits')"
							@keydown.enter="$event.preventDefault()"
						>
							<div class="mt-24 input-box">
								<label for="pr_stocks" class="block label">Stocks</label>
								<div class="input-icon">
									<input
										type="number"
										id="pr_stocks"
										name="pr_stocks"
										@input="checkSumValueInNormalSteps"
										v-model="campos_objetivo.pr_stocks"
										placeholder="%"
										class="w-full h-48 text-sm input-text"
										:class="!isValidModalSimple ? 'isInvalid' : ''"
										:min="0"
										:max="100"
										step="0.01"
									/>
									<svg>
										<use xlink:href="#icon-percent"></use>
									</svg>
								</div>
							</div>
							<div class="mt-16 input-box">
								<label for="pr_reits" class="block label">Reits</label>
								<div class="input-icon">
									<input
										type="number"
										id="pr_reits"
										name="pr_reits"
										@input="checkSumValueInNormalSteps"
										v-model="campos_objetivo.pr_reits"
										placeholder="%"
										class="w-full h-48 text-sm input-text"
										:class="!isValidModalSimple ? 'isInvalid' : ''"
										:min="0"
										:max="100"
										step="0.01"
									/>
									<svg>
										<use xlink:href="#icon-percent"></use>
									</svg>
								</div>
							</div>
							<div
								class="mt-16 error-message texthelper-icon"
								data-tippy-content="helper"
								v-show="!isValidModalSimple && showError"
							>
								<svg>
									<use xlink:href="#icon-helper"></use>
								</svg>
								<span class="text-sm">{{ errorMessage }}</span>
							</div>
							<div
								class="mt-16 aviso-recomendacao text-alert-red-100"
								v-for="aviso in avisosDaFase('mix_eua')"
								:key="aviso.mensagem"
							>
								<svg>
									<use xlink:href="#icon-helper"></use>
								</svg>
								<span class="text-sm">{{ aviso.mensagem }}</span>
							</div>
							<div class="grid grid-cols-12 gap-16 mt-32 btn-container">
								<button
									type="button"
									class="col-span-6 btn bg-primary-10-o text-primary-60-pure"
									:data-id="step.id"
									data-xclose="modal-edicao-objetivo"
									@click="(e)=>onCloseModal(e)"
								>
									Cancelar
								</button>
								<button
									type="submit"
									class="col-span-6 btn"
									:class="isValidModalSimple === true ? '' : 'disabled'"
								>
									{{textoBotao}}
								</button>
							</div>
						</form>
					</div>
				</section>

				<!-- MODAL COM INLINES = STEP 5-->
				<section class="modal--content" data-id="5">
					<div class="py-24 px-24 border-b border-neutral-95">
						<div className="titulo flex items-center justify-between">
							<div class="flex flex-col">
								<p class="text-sm" style="color: rgba(255, 255, 255, 0.70);">
									OBJETIVO
								</p>
								<h3
									class="font-bold text-lg tracking-tighter text-neutral-20 mt-2"
								>
									{{nome}}
								</h3>
							</div>
							<button
								class="close-modal"
								type="button"
								data-id="4"
								data-xclose="modal-edicao-objetivo"
								@click="(e)=>onCloseModal(e)"
							>
								<svg class="w-8 h-8">
									<use xlink:href="#icon-close"></use>
								</svg>
							</button>
						</div>
						<div class="conteudo step-5 pt-24 ">
							<form class="!p-0" @keydown.enter="$event.preventDefault()">
								<div class="tabela-grafico max-h-[350px] overflow-y-scroll">
									<div class="flex justify-between px-8 py-10">
										<p
											class="text-xs font-bold tracking-tight text-white leading-150"
										>
											TOTAL
										</p>
										<p
											class="text-xs font-bold tracking-tight text-primary-50 leading-150"
										>
											{{ valor_total_computado.toFixed(2) }}%
										</p>
									</div>
									<div class="mt-8 header grid-personalizado_novo">
										<p class="label-objetivo">Ativo</p>
										<p class="text-left label-objetivo">%</p>
										<p></p>
									</div>

									<div
										class="item grid-personalizado_novo"
										v-if="this.objetivos[step.tipo]?.length"
										v-for="item in this.objetivos[step.tipo]"
										:key="item.id"
										:class="{active: showOptions == item.id && showOptionsFirst}"
										id="item.id"
									>
										<p class="ticker_symbol-objetivo">{{item.ticker_symbol}}</p>
										<p class="text-left justify-start porcentagem-objetivo">
											{{Number(item.porcentagem_desejada).toFixed(2)}} %
										</p>
										<span
											class="icone-three-points options-objetivo"
											@click="handleClickInOptions(item.id)"
										>
											<svg class="pointer-events-none">
												<use xlink:href="#icon-three-points"></use>
											</svg>
											<ul class="options">
												<li>
													<a
														:id="item.id"
														@click="activateModal('editar', item.objetivo, item.ticker_symbol, item.id)"
														>Editar</a
													>
												</li>
												<li>
													<a :id="item.id" @click="removeObjective(item.id)"
														>Remover</a
													>
												</li>
											</ul>
										</span>
									</div>

									<input
										type="hidden"
										name="secao_Ações"
										:value="JSON.stringify(this.objetivos[step.tipo])"
									/>
								</div>
								<button
									type="button"
									class="w-full mt-4 btn quartenary personalizado"
									@click="activateModal('adicionar')"
									:class="{disabled: isPercentFull}"
									:disabled="isPercentFull"
								>
									Adicionar {{nome}}
								</button>
								<div
									class="mt-16 error-message texthelper-icon"
									data-tippy-content="helper"
									v-show="!isValidModalObjective && showError"
								>
									<svg>
										<use xlink:href="#icon-helper"></use>
									</svg>

									<span class="text-sm">{{ errorMessage }}</span>
								</div>
								<div class="grid grid-cols-12 gap-16 mt-32 btn-container">
									<button
										type="button"
										class=" col-span-6 btn bg-primary-10-o text-primary-60-pure"
										:data-id="step.id"
										data-xclose="modal-edicao-objetivo"
										@click="(e)=>onCloseModal(e)"
									>
										Cancelar
									</button>
									<button
										type="button"
										class="col-span-6 btn icon-left"
										:class="{disabled: !isValidModalObjective}"
										:disabled="isValidModalObjective == false"
										@click="saveANewObjectiveOnApi"
									>
										Concluir
									</button>
								</div>
							</form>
						</div>
					</div>
				</section>
			</div>

			<div class="modal-fundo" :class="{active: modalIsOpen}">
				<div
					class="modal-novo tela-adicao"
					v-show="modalState === 'adicionar'"
					:class="{active: modalIsOpen && modalState === 'adicionar'}"
				>
					<div class="modal-header">
						<img :src="bgModal" alt="" class="bg-header-modal" />
						<h3>Adicionar {{nome}}</h3>
						<button
							class="close-modal"
							type="button"
							data-id="2"
							data-xclose="modal-edicao"
							@click="onCloseModal"
						>
							<svg class="w-8 h-8">
								<use xlink:href="#icon-close"></use>
							</svg>
						</button>
					</div>
					<div class="p-24 modal-content">
						<div class="input-box is-search">
							<label class="label block" for="id_classe_acao"
								>{{textoModal}}</label
							>
							<v-select
								class="select-vue"
								:option-label="'ticker_symbol' "
								:options="product_type_name !== 'TesouroDireto' ? options : optionsRendaFixa"
								v-model="this.novoObjetivo.nome"
								@search="onSearch"
								:loading="isLoading"
								:dropdown-should-open="dropdownShouldOpen"
								@change="preventInsertTheSameTickerSymbol"
								placeholder="Pesquisar..."
								no-options-text="Nenhum resultado encontrado"
								:clearable="false"
								@update:model-value="(e) => handleSearchSelect(e)"
							>
							</v-select>
						</div>
						<div class="input-box">
							<label class="block label mt-16" for="id_objetivo"
								>Objetivo
							</label>
							<div class=" input-icon">
								<input
									type="number"
									v-model="novoObjetivo.porcentagem"
									@keyup="validateModalFieldsOnAdd"
									id="id_objetivo"
									class="w-full h-48 text-sm input-text"
									:class="{disabled: hasSameValue}"
									:disabled="hasSameValue"
									:clearable="false"
								/>
								<svg>
									<use xlink:href="#icon-percent"></use>
								</svg>
							</div>
						</div>
						<div
							class="mt-16 error-message texthelper-icon"
							data-tippy-content="helper"
							v-if="!modalValueIsValid && showErrorOnModal"
						>
							<svg>
								<use xlink:href="#icon-helper"></use>
							</svg>
							<span>{{ modalErrorMessage }}</span>
						</div>
						<div class="grid grid-cols-12 gap-16 mt-32 btn-container">
							<button
								type="button"
								class="col-span-6 btn bg-primary-10-o text-primary-60-pure"
								data-xclose="modal-adicao"
								@click="onCloseModal"
							>
								Cancelar
							</button>
							<button
								type="button"
								class="col-span-6 btn"
								:class="{disabled: !modalValueIsValid}"
								:disabled="!modalValueIsValid"
								@click="saveANewObjective"
							>
								Adicionar
							</button>
						</div>
					</div>
				</div>
				<div
					class="modal-novo tela-edicao"
					v-show="modalState === 'editar'"
					:class="{active: modalIsOpen && modalState === 'editar'}"
				>
					<div class="modal-header">
						<img :src="bgModal" alt="" class="bg-header-modal" />
						<h3>Editar {{nome}}</h3>
						<button
							class="close-modal"
							type="button"
							data-id="2"
							data-xclose="modal-edicao"
							@click="onCloseModal"
						>
							<svg class="w-8 h-8">
								<use xlink:href="#icon-close"></use>
							</svg>
						</button>
					</div>
					<div class="p-24 modal-content">
						<div class="input-box is-search">
							<label class="label block" for="id_classe_acao"
								>{{textoModal}}
							</label>
							<v-select
								class="select-vue"
								name="ticker_symbol"
								:option-label="'ticker_symbol'"
								:options="options"
								v-model="this.novoObjetivo.nome"
								@search="onSearch"
								@input="setNewObjectiveValueInOnKeyupEdit"
								:loading="isLoading"
								:dropdown-should-open="dropdownShouldOpen"
								@change="preventInsertTheSameTickerSymbol"
								placeholder="Pesquisar..."
								no-options-text="Nenhum resultado encontrado"
								:disabled="true"
							></v-select>
						</div>

						<div class="input-box">
							<label class="block label mt-16" for="id_objetivo"
								>Objetivo
							</label>
							<div class=" input-icon">
								<input
									type="number"
									v-model="novoObjetivo.porcentagem"
									@keyup="setNewObjectiveValueInOnKeyupEdit"
									id="id_objetivo"
									class="w-full h-48 text-sm input-text"
								/>
								<svg>
									<use xlink:href="#icon-percent"></use>
								</svg>
							</div>
						</div>
						<div
							class="mt-16 error-message texthelper-icon"
							data-tippy-content="helper"
							v-if="!modalValueIsValid && showErrorOnModal"
						>
							<svg>
								<use xlink:href="#icon-helper"></use>
							</svg>
							<span>{{ modalErrorMessage }}</span>
						</div>
						<div class="grid grid-cols-12 gap-16 mt-32 btn-container">
							<button
								type="button"
								class="col-span-6 btn bg-primary-10-o text-primary-60-pure"
								data-xclose="modal-edicao"
								@click="onCloseModal"
							>
								Cancelar
							</button>
							<button
								type="button"
								class="col-span-6 btn"
								:class="{disabled: !modalValueIsValid}"
								:disabled="!modalValueIsValid"
								@click="editAExistantObjetive"
							>
								Continuar
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	`,
};
export default modalComplexo;
